import { z } from "zod/v4";
import { propertyKeySchema } from "./PropertyKey.js";

export type Empty = Record<PropertyKey, never>;
export const emptySchema = z.record(propertyKeySchema, z.never()).meta({
	// This schema is not supported in the OpenAPI generator, ignoring it.
	type: "unknown",
});
